module.exports = __webpack_public_path__ + "static/media/WPlogo2.ab260496.png";


//////////////////
// WEBPACK FOOTER
// ./src/pics/WPlogo2.png
// module id = 87
// module chunks = 0